import { render, staticRenderFns } from "./IconPopular.vue?vue&type=template&id=48062f6e"
import script from "./IconPopular.vue?vue&type=script&lang=js"
export * from "./IconPopular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports